import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { email, password, repeatPassword, firstname, lastname, role },
} = checkout;

const validations = [
  Yup.object().shape({
    [email.name]: Yup.string().required(email.errorMsg).email(email.invalidMsg),
    [password.name]: Yup.string()
      .required(password.errorMsg)
      .min(8, "Your password should be more than 8 characters.")
      .matches(/[a-z]/, "Your password must contain at least one lowercase letter.")
      .matches(/[A-Z]/, "Your password must contain at least one uppercase letter.")
      .matches(/\d/, "Your password must contain at least one number.")
      .matches(/[^A-Za-z0-9]/, "Your password must contain at least one special character."),
    [repeatPassword.name]: Yup.string()
      .required(repeatPassword.errorMsg)
      .oneOf([Yup.ref("password"), null], repeatPassword.invalidMsg),
    [firstname.name]: Yup.string().required(firstname.errorMsg),
    [lastname.name]: Yup.string().required(lastname.errorMsg),
    [role.name]: Yup.string().required(role.errorMsg),
  }),
];

export default validations;
